import classNames from "classnames";
import React from "react";
export default function UserInfo(props) {
    if (!props.user)
        return null;
    return (React.createElement("div", { className: classNames(props.className, "panel-body-pl panel-body-pr pt-0_75 pb-0_75") },
        React.createElement("div", { className: "font-h5 text-overflow-ellipsis line-height-1", title: props.user.Name || "" }, props.user.Name),
        props.user.Email && (React.createElement("div", { className: "text-muted text-overflow-ellipsis", title: props.user.Email }, props.user.Email))));
}
